import React from "react";
import {
  Box,
  Clapperboard,
  Smartphone,
  Mic,
  FolderArchive,
  Stamp,
  Target,
  Camera,
  ExternalLink,
  CalendarClock,
  FilePlus,
} from "lucide-react";
import { BucketModel } from "@/database";
import { Uploader } from "..";
import { truncateText } from "@/utils/utilFunctions/truncateText";

// Contextual icons for custom buckets — visually distinct from the system
// bucket icons (Video, Film, Music, Library, Layers, Megaphone, Image, Link,
// Tv, Upload) so users can tell system vs team-defined buckets at a glance.
const getBucketIcon = (assetType?: string) => {
  switch ((assetType || "").toLowerCase()) {
    case "video":
      return Clapperboard;
    case "shorts":
      return Smartphone;
    case "audio":
      return Mic;
    case "drive":
    case "library":
      return FolderArchive;
    case "slate":
    case "slates":
      return Stamp;
    case "campaign":
      return Target;
    case "image":
      return Camera;
    case "embed":
      return ExternalLink;
    case "premiere":
      return CalendarClock;
    case "custom":
      return FilePlus;
    default:
      return Box;
  }
};

interface BucketCardProps {
  bucket: BucketModel;
  onFileEvent: (event: string, data: any, cb?: any) => any;
  index?: number;
  onCardClick?: (bucket: BucketModel) => void;
}

export const BucketCard: React.FC<BucketCardProps> = ({
  bucket,
  onFileEvent,
  index = 0,
  onCardClick,
}) => {
  return (
    <Uploader
      key={bucket.id}
      id={bucket.id || ""}
      type={bucket?.asset_type || "video"}
      onFileEvent={onFileEvent}
      datatype={bucket?.asset_type === "audio" ? "AUDIO" : "VIDEO"}
      metaPreset={bucket?.presets_meta}
      socialPreset={bucket?.presets_publishing}
    >
      <div
        className="create-btn bg-white bucket-card-animated"
        role="button"
        style={{ animationDelay: `${index * 60}ms` }}
        onClick={() => onCardClick?.(bucket)}
      >
        <div className="card-link create-item">
          {(() => {
            const Icon = getBucketIcon(bucket?.asset_type);
            return <Icon size={32} strokeWidth={1.5} />;
          })()}
          <span className="mt-1 mb-1">
            {truncateText(bucket.name || "Unnamed Bucket", 20) ||
              "Unnamed Bucket"}
          </span>
        </div>
      </div>
    </Uploader>
  );
};
